
































































import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Component } from '@niknevis/vue-modules'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import Vue from 'vue'
import { BaseRemoteDataUseCaseInterface } from '@/modules/shared/interfaces/base-remote-data-use-case.interface'

@Component({
  components: {
    BaseButton,
    Confirm
  }
})
export default class AdminCampaignCompleteButton extends Vue {
  @Prop({ required: true }) makeCompletedUseCase: BaseRemoteDataUseCaseInterface
  @Prop({ required: true }) id!: number
  @Prop({ default: 'تکمیل کردن' }) label?: string

  showDialog = false

  sendRequest() {
    this.makeCompletedUseCase.execute(this.id)
      .then(() => {
        this.showDialog = false
      })
  }
}
